import "core-js/modules/es6.object.assign";
import _classCallCheck from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/circleci/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import React from "react";
import { Generic } from "../../base";
import { combineRefs } from "../../utils";
import { NavbarItemContext } from "./navbar-item-context";
export var NavbarItemContainer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(NavbarItemContainer, _React$PureComponent);

  function NavbarItemContainer(props) {
    var _this;

    _classCallCheck(this, NavbarItemContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NavbarItemContainer).call(this, props));
    _this.ref = React.createRef();

    _this.handleDocumentClick = function (event) {
      if (_this.props.managed !== true && _this.active && _this.ref.current !== null) {
        if (event.target instanceof Element && !_this.ref.current.contains(event.target)) {
          _this.active = false;
        }
      }
    };

    _this.handleOnClick = function (ctx) {
      return function (event) {
        if (_this.props.onClick !== undefined) {
          _this.props.onClick(event);
        }

        ctx.setActive(!ctx.active);
      };
    };

    _this.state = {
      active: props.active === true
    };
    return _this;
  }

  _createClass(NavbarItemContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.dropdown === true) {
        document.addEventListener("click", this.handleDocumentClick);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("click", this.handleDocumentClick);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          as = _a.as,
          active = _a.active,
          initialClassName = _a.className,
          dropdown = _a.dropdown,
          expanded = _a.expanded,
          hoverable = _a.hoverable,
          innerRef = _a.innerRef,
          managed = _a.managed,
          onClick = _a.onClick,
          tab = _a.tab,
          up = _a.up,
          rest = tslib_1.__rest(_a, ["as", "active", "className", "dropdown", "expanded", "hoverable", "innerRef", "managed", "onClick", "tab", "up"]);

      var className = classNames("navbar-item", {
        "has-dropdown": dropdown,
        "has-dropdown-up": up,
        "is-active": this.active,
        "is-expanded": expanded,
        "is-hoverable": hoverable,
        "is-tab": tab
      }, initialClassName);
      var ref = combineRefs(this.ref, innerRef);

      if (dropdown === true) {
        var asOverride = as === "a" ? "div" : as;
        return React.createElement(NavbarItemContext.Provider, {
          value: {
            active: this.active,
            setActive: function setActive(value) {
              return _this2.active = value;
            }
          }
        }, React.createElement(Generic, Object.assign({
          as: asOverride,
          className: className,
          ref: ref
        }, rest)));
      }

      return React.createElement(NavbarItemContext.Consumer, null, function (ctx) {
        return React.createElement(Generic, Object.assign({
          as: as,
          className: className,
          onClick: _this2.handleOnClick(ctx),
          ref: ref
        }, rest));
      });
    }
  }, {
    key: "active",
    get: function get() {
      return this.props.managed === true ? this.props.active === true : this.state.active;
    },
    set: function set(value) {
      if (this.props.managed !== true) {
        this.setState({
          active: value
        });
      }
    }
  }]);

  return NavbarItemContainer;
}(React.PureComponent);
NavbarItemContainer.displayName = "Navbar.Item.Container";